require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/$.core').Number.isInteger;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/number/is-integer.js
// module id = 1026
// module chunks = 2